var root = require('./_root');

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/lodash/_coreJsData.js
// module id = 796
// module chunks = 0 1 2 3 4 5 6 7 8